import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "./QuickNavigation.css"
import croPerformanceIcon from '../assets/CROPerformanceIcon.png'; // Adjust the path to your logo file
import streamViewerIcon from '../assets/StreamViewerIcon.png'; // Adjust the path to your logo file

const QuickNavigation = () => {

  const columns = [
    { headerName: "ID", field: "id" },
    { headerName: "Path", field: "path" },
    {
      headerName: "Issue URL",
      field: "issue_ext_reference_id",
      cellRenderer: (params) => {
        const id = params.value;
        // url.searchParams.append('issue_extid', params.data.issue_extid);
        return <a href={`/issueDetails/${id}`} target="_blank" rel="noopener noreferrer">View Issue</a>;
      }
    },
    { headerName: "Status", field: "status" },
    { headerName: "Assay Type", field: "config_type" },
    { headerName: "Assay Provider Contact", field: "cro_contact" },
    { headerName: "Data File Assay Provider", field: "data_file_cro" },
    { headerName: "Data File Program", field: "data_file_program" },
    { headerName: "Labels", field: "labels" },
    { headerName: "Last Updated", field: "last_updated" },
    { headerName: "Creation Date", field: "creation_date" },
  ];

  return (
    <div className="ag-theme-alpine" style={{ height: 100, marginBottom:40, marginTop:40, width:1200 }}>
      <div style={{ fontSize:"20px",margin:"10px", marginBottom:20 }}>Quick Navigation</div>
      <div style={{ display:"flex", justifyContent:"space-between"}}>
        <div></div>
        <div style={{ display:"flex", width:"25%", alignItems:"center"}}>
          <div>
            <a href="/home"><img src={croPerformanceIcon} alt="Logo" style={{ height:"80px"}} /></a>
          </div>
          <div style={{ margin:20, fontSize:16 }}>
            Assay Provider Performance Reports
          </div>
        </div>
        <div></div>
        <div style={{ display:"flex", width:"25%", alignItems:"center", }}>
          <div>
            <a href="/inventory/live-tracking"><img src={streamViewerIcon} alt="Logo" style={{ height:"80px"}} /></a>
          </div>
          <div style={{ margin:20, fontSize:16 }}>
            Inventory Live Stream
          </div>
        </div>
        <div></div>
        {/* <div style={{ display:"flex", width:"25%", alignItems:"center"}}>
          <div>
            <a href="/assay/live-tracking"><img src={streamViewerIcon} alt="Logo" style={{ height:"80px"}} /></a>
          </div>
          <div style={{ margin:20, fontSize:16 }}>
            Assay Live Stream
          </div>
        </div> */}
        <div></div>
      </div>
    </div>
  );
};

export default QuickNavigation;
